import getSymbolFromCurrency from "currency-symbol-map";
import React from "react";
import { NumberFormatValues, NumericFormat } from "react-number-format";
import ReactCountryFlag from "react-country-flag";
import BareInput, {
  BareInputProps,
  flagSizeVariants,
} from "components/DesignSystem/Input/BareInput";

export const getCurrencySymbol = (currencyCode: string) =>
  getSymbolFromCurrency(currencyCode) ?? currencyCode;

export interface PriceInputProps
  extends Omit<BareInputProps, "type" | "defaultValue" | "leftComponent"> {
  currencyCode?: string;
  showCurrencyFlag?: boolean;
}

const BarePriceInput = React.forwardRef<HTMLInputElement, PriceInputProps>(
  (
    {
      currencyCode = "USD",
      customSize = "regular",
      variant,
      disabled,
      onChange,
      className,
      value,
      rightComponent,
      showCurrencyFlag = false,
      ...inputProps
    },
    ref
  ) => {
    const currencySymbol = getCurrencySymbol(currencyCode);
    const countryCode = currencyCode.slice(0, 2);

    return (
      <NumericFormat
        getInputRef={ref}
        customInput={BareInput}
        inputMode="decimal"
        placeholder="0.00"
        thousandSeparator=","
        decimalScale={2}
        fixedDecimalScale
        valueIsNumericString
        value={value as string | number | undefined}
        disabled={disabled}
        className={className}
        customSize={customSize}
        variant={variant}
        leftComponent={currencySymbol}
        showLeftSeparator={false}
        rightComponent={
          showCurrencyFlag ? (
            <div className="t-flex t-items-center t-self-stretch">
              <span className="t-self-stretch t-flex t-items-center t-pr-3 t-text-neutral-20 t-flex-none t-shrink-0 sm:t-pr-2">
                |
              </span>
              <div className="t-flex t-items-center t-gap-1.5 t-text-text-30 t-text-body-sm">
                <ReactCountryFlag
                  countryCode={countryCode}
                  svg
                  className={flagSizeVariants({ size: customSize })}
                />
                <span className="sm:t-hidden">{currencyCode}</span>
              </div>
            </div>
          ) : (
            rightComponent
          )
        }
        onValueChange={(values: NumberFormatValues) => {
          onChange?.({
            target: { value: values.value },
          } as React.ChangeEvent<HTMLInputElement>);
        }}
        {...inputProps}
      />
    );
  }
);

BarePriceInput.displayName = "BarePriceInput";

export default BarePriceInput;
